export default {
  items: [
    {
      title: 'businessDocumentationSoftware.nav.title',
      id: 'BusinessDocumentationSoftware',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'businessDocumentationSoftware.nav.title',
          to: { name : 'BusinessDocumentationSoftwareIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
